import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defaultTo, times } from 'ramda';
import { withFormik } from 'formik';
import Select from 'react-select';

import { apiManuallyPayForCertification } from '../../api/certification';
import { handleError, handleSuccess } from '../../util/forms';

import Modal from '../Modal';
import EditField from '../Forms/EditField';

class CertificationPaymentModal extends Component {
  static propTypes = {
    userCertification: PropTypes.object,
    onHide: PropTypes.func,
    updatePayments: PropTypes.func,
    highestPaidYear: PropTypes.number,
  };

  state = {
    show: false,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState && !prevState.show && nextProps.show && nextProps.resetForm) {
      nextProps.resetForm();
    }

    return { show: defaultTo(false, nextProps.show) };
  }

  render() {
    const {
      onHide,
      values,
      handleBlur,
      handleChange,
      handleSubmit,
      setFieldValue,
      isSubmitting,
      isValid,
      status,
    } = this.props;
    const { show } = this.state;
    const currentYear = new Date().getFullYear();

    return (
      <Modal show={show} onHide={onHide} title="Add Payment">
        <form>
          <Modal.Body className="px-5">
            <EditField
              full
              as={Select}
              bare
              simpleValue
              label="Year"
              name="year"
              status={status}
              onChange={(value) => setFieldValue('year', value)}
              onBlur={handleBlur}
              value={values.year}
              options={times((i) => {
                const year = currentYear - (i - 10);
                return { value: year, label: year };
              }, 21)}
            />
            <EditField
              full
              type="number"
              name="price"
              label="Price"
              status={status}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.price}
            />
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="btn btn-secondary" onClick={onHide}>
              Close
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={!isValid || isSubmitting}
              onClick={handleSubmit}
            >
              Save changes
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

export default withFormik({
  handleSubmit: (payload, formProps) => {
    const { props } = formProps;

    apiManuallyPayForCertification({ ...payload, price: payload.price * 100 })
      .then(({ data }) => props.updatePayments(data))
      .then(() => handleSuccess(formProps))
      .then(props.onHide)
      .catch((err) => handleError(formProps, err));
  },
  mapPropsToValues: ({ userCertification = {}, highestPaidYear }) => {
    return {
      userId: userCertification.userId,
      year: highestPaidYear ? highestPaidYear + 1 : new Date().getFullYear(),
      price: 0,
    };
  },
  isInitialValid: true,
  validateOnChange: true,
})(CertificationPaymentModal);
